var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTag = function SvgTag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none",
    viewBox: "0 0 18 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M1 2.24C1 1.56 1.55 1 2.24 1h4.12c.69 0 1.64.4 2.12.88l8.16 8.16c.48.48.48 1.26 0 1.75l-4.85 4.85c-.49.48-1.27.48-1.76 0L1.88 8.48A3.43 3.43 0 0 1 1 6.36V2.24Z",
    clipRule: "evenodd",
    vectorEffect: "non-scaling-stroke"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4.64 6.1a1.45 1.45 0 1 0 0-2.92 1.45 1.45 0 0 0 0 2.91Z",
    clipRule: "evenodd"
  })));
};
export default SvgTag;